import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/banner2-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./HKASMediationRulesPage.scss";

const HKASMediationRulesPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title">
          <h1 className="banner-main-title">{t("mediation_rules_page_header")}</h1>
          <p className="banner-subtitle">{t("mediation_rules_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_mediation_rules_page_link1")}</Link>
        <span>{t("breadcrumbs_mediation_rules_page_span")}</span>
        <Link>{t("breadcrumbs_mediation_rules_page_link2")}</Link>
      </Breadcrumbs>
      <main className="mediation-rules-main-container">
        <header className="mediation-rules-header-section">
          <h2 className="mediation-rules-section-title">{t("mediation_rules_page_header")}</h2>
        </header>
        <section className="mediation-rules-content-section">
        <div className="item">
          <Button
            id="toggler"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article1")}
          </Button>
          <UncontrolledCollapse toggler="#toggler">
            <Card>
              <CardBody>{t("mediation_rules_article1_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler1"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article2")}
          </Button>
          <UncontrolledCollapse toggler="#toggler1">
            <Card>
              <CardBody>
                <ul>
                  <li>{t("mediation_rules_article2_text1")}</li>
                </ul>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler2"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article3")}
          </Button>
          <UncontrolledCollapse toggler="#toggler2">
            <Card>
              <CardBody>
                <ul>
                  <li>{t("application_of_rules")}</li>
                </ul>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler3"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article4")}
          </Button>
          <UncontrolledCollapse toggler="#toggler3">
            <Card>
              <CardBody>
                <span>{t("mediation_rules_article3_text1")}</span>
                <ul className="list">
                  <li>{t("mediation_rules_article3_text2")}</li>
                  <li>{t("mediation_rules_article3_text3")}</li>
                  <li>{t("mediation_rules_article3_text4")}</li>
                  <li>{t("mediation_rules_article3_text5")}</li>
                  <li>{t("mediation_rules_article3_text6")}</li>
                  <li>{t("mediation_rules_article3_text7")}</li>
                  <li>{t("mediation_rules_article3_text8")}</li>
                </ul>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler4"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article5")}
          </Button>
          <UncontrolledCollapse toggler="#toggler4">
            <Card>
              <CardBody>
                <ul className="list">
                  <li>{t("mediation_rules_article4_text1")}</li>
                  <li>{t("mediation_rules_article4_text2")}</li>
                </ul>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler5"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article6")}
          </Button>
          <UncontrolledCollapse toggler="#toggler5">
            <Card>
              <CardBody>
                <ul className="list">
                  <li>{t("mediation_rules_article5_text1")}</li>
                  <li>{t("mediation_rules_article5_text2")}</li>
                  <li>{t("mediation_rules_article5_text3")}</li>
                  <li>{t("mediation_rules_article5_text4")}</li>
                  <li>{t("mediation_rules_article5_text5")}</li>
                  <li>{t("mediation_rules_article5_text6")}</li>
                </ul>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler6"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article7")}
          </Button>
          <UncontrolledCollapse toggler="#toggler6">
            <Card>
              <CardBody>{t("mediation_rules_article6_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler7"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article8")}
          </Button>
          <UncontrolledCollapse toggler="#toggler7">
            <Card>
              <CardBody>{t("mediation_rules_article7_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler8"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article9")}
          </Button>
          <UncontrolledCollapse toggler="#toggler8">
            <Card>
              <CardBody>​{t("mediation_rules_article8_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler9"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article10")}
          </Button>
          <UncontrolledCollapse toggler="#toggler9">
            <Card>
              <CardBody>{t("mediation_rules_article9_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler10"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article11")}
          </Button>
          <UncontrolledCollapse toggler="#toggler10">
            <Card>
              <CardBody>​{t("mediation_rules_article10_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler11"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article12")}
          </Button>
          <UncontrolledCollapse toggler="#toggler11">
            <Card>
              <CardBody>
                ​<span>​{t("mediation_rules_article11_text1")}</span>
                <ul className="list">
                  <li>​{t("mediation_rules_article11_text2")}</li>
                  <li>​{t("mediation_rules_article11_text3")}</li>
                  <li>​{t("mediation_rules_article11_text4")}</li>
                  <li>​{t("mediation_rules_article11_text5")}</li>
                  <li>​{t("mediation_rules_article11_text6")}</li>
                </ul>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler12"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article13")}
          </Button>
          <UncontrolledCollapse toggler="#toggler12">
            <Card>
              <CardBody>
                <ul className="list">
                  <li>​{t("mediation_rules_article12_text1")}</li>
                  <li>​{t("mediation_rules_article12_text2")}</li>
                </ul>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler13"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article14")}
          </Button>
          <UncontrolledCollapse toggler="#toggler13">
            <Card>
              <CardBody>
                <p  className="mb-3">​{t("mediation_rules_article13_text1")}</p>
                <ul className="list">
                  <li>​{t("mediation_rules_article13_text2")}</li>
                  <li>​{t("mediation_rules_article13_text3")}</li>
                  <li>​{t("mediation_rules_article13_text4")}</li>
                </ul>
                <p  className="mb-3">​{t("mediation_rules_article13_text5")}</p>
                <p  className="mb-3">​{t("mediation_rules_article13_text6")}</p>
              </CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler14"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article15")}
          </Button>
          <UncontrolledCollapse toggler="#toggler14">
            <Card>
              <CardBody>​{t("mediation_rules_article14_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler15"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article16")}
          </Button>
          <UncontrolledCollapse toggler="#toggler15">
            <Card>
              <CardBody>​{t("mediation_rules_article15_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler16"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article17")}
          </Button>
          <UncontrolledCollapse toggler="#toggler16">
            <Card>
              <CardBody>​{t("mediation_rules_article16_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        <div className="item">
          <Button
            id="toggler17"
            style={{
              marginLeft: "20px",
              marginBottom: "1rem",
              backgroundColor: "white",
              border: "none",
              color: "gray",
              borderLeft: "10px solid #790b1b",
              borderRadius: "0px",
              height: "20px",
              paddingTop: "0px",
              width: "100%",
              textAlign: "start",
            }}
          >
            {t("mediation_rules_article18")}
          </Button>
          <UncontrolledCollapse toggler="#toggler17">
            <Card>
              <CardBody>​{t("mediation_rules_article17_text1")}</CardBody>
            </Card>
          </UncontrolledCollapse>
        </div>
        </section>
      </main>
      <section className="temporary">
        <img src={BottomLogoImg} alt="" />
      </section>

      <Footer />
    </>
  );
};

export default HKASMediationRulesPage;
